import React from 'react';
import { getDatalakeImageUrl } from '../Helpers/DateLakeStorage';

export const acceptedCardWithImages = [
    {
        type: "Visa",
        src: getDatalakeImageUrl("visa.png")
    },
    {
        type: "Mastercard",
        src: getDatalakeImageUrl("mastercard.png")
    },
    {
        type: "AMEX",
        src: getDatalakeImageUrl("amex.png")
    },
    {
        type: "Discover",
        src: getDatalakeImageUrl("discover.png")
    },
    {
        type: "JCB",
        src: getDatalakeImageUrl("jcb.png")
    },
    {
        type: "Maestro",
        src: getDatalakeImageUrl("maestro.png")
    },
    {
        type: "Union Pay",
        src: getDatalakeImageUrl("union pay.png")
    }
];

function AcceptedCardTypes({ className }) {
    return (
        <div className={`d-flex ${className}`}>
            {
                acceptedCardWithImages.map(image => (
                    <img
                        className='cardImg img-fluid'
                        min-height='34px'
                        src={image.src}
                        key={image.type}
                        alt={image.type} />
                ))
            }
        </div>
    )
}

export default AcceptedCardTypes;